// extracted by mini-css-extract-plugin
export default {"wrapper":"Search_wrapper__MZibw","input":"Search_input__6YP1A","item":"Search_item__KFvTY","search":"Search_search__NR-zE","closer":"Search_closer__c906B"};